import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../axiosInstance";
import Swal from "sweetalert2";
import AdLayout from '../components/AdLayout';
import { useNavigate } from "react-router-dom";
import { API_URL_All } from "../api";
import { toast } from "react-toastify";
import "../css/post.css";

const PostsPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Fetch posts from the API
  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axiosInstance.get(`${API_URL_All}/api/posts/`);
        setPosts(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching posts:", error);
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  const handleUpdate = (id) => {
    navigate(`/admin/posts/createOrUpdate/${id}`);
  };

  const handleDelete = async (id) => {
    // Show confirmation dialog before proceeding with deletion
    const result = await Swal.fire({
      title: "Bạn có chắc chắn?",
      text: "Sau khi xóa, bạn sẽ không thể khôi phục bài viết này.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Xóa",
      cancelButtonText: "Hủy",
    });

    // Proceed with the delete operation if the user confirmed
    if (result.isConfirmed) {
      try {
        // Send DELETE request to API
        await axiosInstance.delete(`${API_URL_All}/api/posts/${id}`);

        // Update the state to remove the deleted post
        const updatedPosts = posts.filter((post) => post.id !== id);
        setPosts(updatedPosts);

        toast.success("Bài viết đã được xóa thành công.", { position: "top-right" });
      } catch (error) {
        toast.error("Đã xảy ra lỗi: ", error.response?.data || error.message);
      }
    }
  };

  if (loading) {
    return <p className="d-flex justify-content-center align-items-center min-vh-100">Đang tải dữ liệu..</p>;
  }

  return (
    <AdLayout>
      <div className="table-responsive web-table">
        <div className="container-fluid">
          <div className="row bg-dark">
            <div className="col-12 col-md-2 py-1 fw-bold text-white text-uppercase d-flex align-items-center">
              Quản lý bài viết
            </div>
            <div className="col-12 col-md-8 order-3 order-md-1 py-1">
              <button className="btn btn-success btn-sm" onClick={() => navigate("/admin/posts/createOrUpdate/0")}>
                <i className="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row mt-2">
            {posts.map((post) => (
              <div key={post.id} className="col-md-4 mb-4">
                <div className="d-flex flex-column">
                  <img
                    src={post.mainImageUrl}
                    alt={post.title}
                    className="img-fluid"
                    style={{ maxHeight: "200px", minHeight: "200px", objectFit: "cover" }}
                  />
                  <div className="card-body">
                    <h3 className="card-title" style={{ maxHeight: "90px", minHeight: '90px' }}>{post.title}</h3>
                    <p style={{ maxHeight: "50px", minHeight: '50px' }}>
                      {post.description.replace(/(<([^>]+)>)/gi, "").slice(0, 100)}...
                    </p>
                    <button className="btn btn-primary me-2 btn-sm" onClick={() => handleUpdate(post.id)} title="Sửa">
                      <i className="fas fa-pen"></i>
                    </button>
                    <button className="btn btn-danger btn-sm" title="Xóa" onClick={() => handleDelete(post.id)}>
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </AdLayout>
  );
};

export default PostsPage;
